import { Navbar } from "@/components/navbar";
import { Footer } from "@/components/footer";
import { ContactForm } from "@/components/form";

export default function FormPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Navbar />
      <main className="container mx-auto flex-grow px-4 py-16">
        <div className="mx-auto max-w-3xl">
          <h1 className="mb-8 text-center text-3xl font-bold">Contact Us</h1>
          <p className="mb-12 text-center text-gray-600">
            Fill out the form below and we'll get back to you as soon as possible.
          </p>
          <ContactForm />
        </div>
      </main>
      <Footer />
    </div>
  );
}
